import './readOnlyCell.scss';

import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

const bem = bemFactory.block('reqf-readonly-cell');
const qa = bemFactory.qa('reqf-readonly-cell');

interface ReadOnlyCellProps {
    text: string | undefined;
    className?: string;
    multiline?: boolean;
    invalid?: boolean;
}

export const ReadOnlyCell: FC<ReadOnlyCellProps> = memo((props) => {
    const { className, text, multiline, invalid } = props;

    return (
        <div
            className={bem.add(className)(null, { multiline, invalid })}
            title={invalid ? undefined : text}
            data-qa={qa()}
        >
            {text}
        </div>
    );
});

ReadOnlyCell.displayName = 'ReadOnlyCell';
